export default __webpack_public_path__ + "static/media/Miami_Dade_College.f98666b0.svg";